@if (mode === 'inline') {
  <div class="filters-row">
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select
        multiple
        [ngModel]="values.selectedAgentIds"
        [placeholder]="'All Agents' | translate"
        (ngModelChange)="onFieldChange('selectedAgentIds', $event)">
        <mat-option>
          <ngx-mat-select-search
            [ngModel]="agents.query"
            (ngModelChange)="agents.search($event)"
            [placeholderLabel]="'Search' | translate"
            [noEntriesFoundLabel]="'No options found' | translate">
            @if (values.selectedAgentIds.length) {
              <app-multi-select-clear
              (cleared)="clearAgents()"></app-multi-select-clear>
            }
          </ngx-mat-select-search>
        </mat-option>
        @for (agent of agents.display; track trackById($index, agent)) {
          <mat-option [value]="agent.id">
            {{ agent.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select
        multiple
        [ngModel]="values.selectedAgentGroupIds"
        [placeholder]="'All Agent Groups' | translate"
        (ngModelChange)="onFieldChange('selectedAgentGroupIds', $event)">
        <mat-option>
          <ngx-mat-select-search
            [ngModel]="agentGroups.query"
            (ngModelChange)="agentGroups.search($event)"
            [placeholderLabel]="'Search' | translate"
            [noEntriesFoundLabel]="'No options found' | translate">
            @if (values.selectedAgentGroupIds.length) {
              <app-multi-select-clear
              (cleared)="clearAgentGroups()"></app-multi-select-clear>
            }
          </ngx-mat-select-search>
        </mat-option>
        @for (group of agentGroups.display; track trackById($index, group)) {
          <mat-option [value]="group.id">
            {{ group.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select
        multiple
        [ngModel]="values.selectedSurveyTypeIds"
        [placeholder]="'All Survey Types' | translate"
        (ngModelChange)="onFieldChange('selectedSurveyTypeIds', $event)">
        <mat-option>
          <ngx-mat-select-search
            [ngModel]="surveyTypes.query"
            (ngModelChange)="surveyTypes.search($event)"
            [placeholderLabel]="'Search' | translate"
            [noEntriesFoundLabel]="'No options found' | translate">
            @if (values.selectedSurveyTypeIds.length) {
              <app-multi-select-clear
              (cleared)="clearSurveyTypes()"></app-multi-select-clear>
            }
          </ngx-mat-select-search>
        </mat-option>
        @for (type of surveyTypes.display; track trackById($index, type)) {
          <mat-option [value]="type.id">
            {{ type.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select
        [value]="values.selectedOelTypeId"
        [placeholder]="'All OEL Standards' | translate"
        (valueChange)="onFieldChange('selectedOelTypeId', $event)">
        <mat-option>
          <ngx-mat-select-search
            [ngModel]="oelTypes.query"
            (ngModelChange)="oelTypes.search($event)"
            [placeholderLabel]="'Search' | translate"
            [noEntriesFoundLabel]="'No options found' | translate">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option [value]="null">{{ "All OEL Standards" | translate }}</mat-option>
        @for (oel of oelTypes.filtered; track trackById($index, oel)) {
          <mat-option [value]="oel.id">{{ oel.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field filter-field-wide">
      <mat-select
        [value]="values.selectedTimePeriod"
        [placeholder]="'Time Period' | translate"
        (valueChange)="onTimePeriodChange($event)">
        @for (period of timePeriodOptionsWithRange; track trackById($index, period)) {
          <mat-option [value]="period.id">
            {{ period.id === ExceedanceTimePeriod.Custom ? customTimePeriodLabel : period.displayName }}
          </mat-option>
        }
      </mat-select>
      @if (values.selectedTimePeriod === ExceedanceTimePeriod.Custom) {
        <button
          mat-icon-button
          matIconSuffix
          type="button"
          class="custom-date-edit-btn"
          (click)="$event.stopPropagation(); openCustomDateDialog(values.selectedTimePeriod)">
          <mat-icon>edit_calendar</mat-icon>
        </button>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select
        [value]="values.selectedJurisdictionId"
        [placeholder]="'All Jurisdictions' | translate"
        (valueChange)="onFieldChange('selectedJurisdictionId', $event)">
        <mat-option>
          <ngx-mat-select-search
            [ngModel]="jurisdictions.query"
            (ngModelChange)="jurisdictions.search($event)"
            [placeholderLabel]="'Search' | translate"
            [noEntriesFoundLabel]="'No options found' | translate">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option [value]="null">{{ "All Jurisdictions" | translate }}</mat-option>
        @for (j of jurisdictions.filtered; track trackById($index, j)) {
          <mat-option [value]="j.id">{{ j.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select
        [value]="values.selectedSampleCategoryId"
        [placeholder]="'All Sample Categories' | translate"
        (valueChange)="onFieldChange('selectedSampleCategoryId', $event)">
        <mat-option>
          <ngx-mat-select-search
            [ngModel]="sampleCategories.query"
            (ngModelChange)="sampleCategories.search($event)"
            [placeholderLabel]="'Search' | translate"
            [noEntriesFoundLabel]="'No options found' | translate">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option [value]="null">{{ "All Sample Categories" | translate }}</mat-option>
        @for (cat of sampleCategories.filtered; track trackById($index, cat)) {
          <mat-option [value]="cat.id">{{ cat.name | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select
        [value]="values.selectedSampleTypeId"
        [placeholder]="'All Sample Types' | translate"
        (valueChange)="onFieldChange('selectedSampleTypeId', $event)">
        <mat-option>
          <ngx-mat-select-search
            [ngModel]="sampleTypes.query"
            (ngModelChange)="sampleTypes.search($event)"
            [placeholderLabel]="'Search' | translate"
            [noEntriesFoundLabel]="'No options found' | translate">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option [value]="null">{{ "All Sample Types" | translate }}</mat-option>
        @for (st of sampleTypes.filtered; track trackById($index, st)) {
          <mat-option [value]="st.id" [disabled]="disabledSampleTypeIds.has(st.id)">
            <span class="sample-type-option"
              [matTooltip]="'Not available for the selected agent(s).' | translate"
              [matTooltipDisabled]="!disabledSampleTypeIds.has(st.id)">
              <span class="sample-type-name">{{ st.name | translate }}</span>
              @if (disabledSampleTypeIds.has(st.id)) {
                <i class="material-icons sample-type-lock">lock</i>
              }
            </span>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <ng-content select="[filterAppend]"></ng-content>
  </div>
}

@if (mode === 'config') {
  <div class="widget-config-fields">
    <div class="config-field">
      <label>{{ "Agent" | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select
          multiple
          [ngModel]="values.selectedAgentIds"
          [placeholder]="'All Agents' | translate"
          (ngModelChange)="onFieldChange('selectedAgentIds', $event)">
          <mat-option>
            <ngx-mat-select-search
              [ngModel]="agents.query"
              (ngModelChange)="agents.search($event)"
              [placeholderLabel]="'Search' | translate"
              [noEntriesFoundLabel]="'No options found' | translate">
              @if (values.selectedAgentIds.length) {
                <app-multi-select-clear
                (cleared)="clearAgents()"></app-multi-select-clear>
              }
            </ngx-mat-select-search>
          </mat-option>
          @for (agent of agents.display; track trackById($index, agent)) {
            <mat-option [value]="agent.id">
              {{ agent.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ "Agent Group" | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select
          multiple
          [ngModel]="values.selectedAgentGroupIds"
          [placeholder]="'All Agent Groups' | translate"
          (ngModelChange)="onFieldChange('selectedAgentGroupIds', $event)">
          <mat-option>
            <ngx-mat-select-search
              [ngModel]="agentGroups.query"
              (ngModelChange)="agentGroups.search($event)"
              [placeholderLabel]="'Search' | translate"
              [noEntriesFoundLabel]="'No options found' | translate">
              @if (values.selectedAgentGroupIds.length) {
                <app-multi-select-clear
                (cleared)="clearAgentGroups()"></app-multi-select-clear>
              }
            </ngx-mat-select-search>
          </mat-option>
          @for (group of agentGroups.display; track trackById($index, group)) {
            <mat-option [value]="group.id">
              {{ group.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ "Survey Type" | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select
          multiple
          [ngModel]="values.selectedSurveyTypeIds"
          [placeholder]="'All Survey Types' | translate"
          (ngModelChange)="onFieldChange('selectedSurveyTypeIds', $event)">
          <mat-option>
            <ngx-mat-select-search
              [ngModel]="surveyTypes.query"
              (ngModelChange)="surveyTypes.search($event)"
              [placeholderLabel]="'Search' | translate"
              [noEntriesFoundLabel]="'No options found' | translate">
              @if (values.selectedSurveyTypeIds.length) {
                <app-multi-select-clear
                (cleared)="clearSurveyTypes()"></app-multi-select-clear>
              }
            </ngx-mat-select-search>
          </mat-option>
          @for (type of surveyTypes.display; track trackById($index, type)) {
            <mat-option [value]="type.id">
              {{ type.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ "OEL Standard" | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select
          [ngModel]="values.selectedOelTypeId"
          [placeholder]="'All OEL Standards' | translate"
          (ngModelChange)="onFieldChange('selectedOelTypeId', $event)">
          <mat-option [value]="null">{{ "All OEL Standards" | translate }}</mat-option>
          @for (oel of oelTypes.filtered; track trackById($index, oel)) {
            <mat-option [value]="oel.id">{{ oel.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ "Time Period" | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select
          [ngModel]="values.selectedTimePeriod"
          [placeholder]="'Default (Last 12 Months)' | translate"
          (ngModelChange)="onTimePeriodChange($event)">
          <mat-option [value]="null">{{ "Default (Last 12 Months)" | translate }}</mat-option>
          @for (period of timePeriodOptionsWithRange; track trackById($index, period)) {
            <mat-option [value]="period.id">
              {{ period.id === ExceedanceTimePeriod.Custom ? customTimePeriodLabel : period.displayName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (values.selectedTimePeriod === ExceedanceTimePeriod.Custom) {
      <div class="config-field">
        <label>{{ "Custom Range" | translate }}</label>
        <button mat-stroked-button type="button" class="custom-date-btn"
          (click)="openCustomDateDialog(values.selectedTimePeriod)">
          <mat-icon>edit_calendar</mat-icon>
          {{ customTimePeriodLabel }}
        </button>
      </div>
    }
    <div class="config-field">
      <label>{{ "Jurisdiction" | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select
          [ngModel]="values.selectedJurisdictionId"
          [placeholder]="'All Jurisdictions' | translate"
          (ngModelChange)="onFieldChange('selectedJurisdictionId', $event)">
          <mat-option>
            <ngx-mat-select-search
              [ngModel]="jurisdictions.query"
              (ngModelChange)="jurisdictions.search($event)"
              [placeholderLabel]="'Search' | translate"
              [noEntriesFoundLabel]="'No options found' | translate">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option [value]="null">{{ "All Jurisdictions" | translate }}</mat-option>
          @for (j of jurisdictions.filtered; track trackById($index, j)) {
            <mat-option [value]="j.id">
              {{ j.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ "Sample Category" | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select
          [ngModel]="values.selectedSampleCategoryId"
          [placeholder]="'All Sample Categories' | translate"
          (ngModelChange)="onFieldChange('selectedSampleCategoryId', $event)">
          <mat-option [value]="null">{{ "All Sample Categories" | translate }}</mat-option>
          @for (cat of sampleCategories.items; track trackById($index, cat)) {
            <mat-option [value]="cat.id">{{ cat.name | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ "Sample Type" | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select
          [ngModel]="values.selectedSampleTypeId"
          [placeholder]="'All Sample Types' | translate"
          (ngModelChange)="onFieldChange('selectedSampleTypeId', $event)">
          <mat-option [value]="null">{{ "All Sample Types" | translate }}</mat-option>
          @for (st of sampleTypes.filtered; track trackById($index, st)) {
            <mat-option [value]="st.id" [disabled]="disabledSampleTypeIds.has(st.id)">
              <span class="sample-type-option"
                [matTooltip]="'Not available for the selected agent(s).' | translate"
                [matTooltipDisabled]="!disabledSampleTypeIds.has(st.id)">
                <span class="sample-type-name">{{ st.name | translate }}</span>
                @if (disabledSampleTypeIds.has(st.id)) {
                  <i class="material-icons sample-type-lock">lock</i>
                }
              </span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}
